import { type ComponentPropsWithRef, forwardRef, useState } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = Omit<ComponentPropsWithRef<"input">, "type"> & {
  type?: "text" | "number" | "email" | "password" | "tel";
  hasError?: boolean;
};

export const TextField = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const { hasError, className, type = "text", ...restProps } = props;

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const input = (
    <input
      type={type === "password" && isPasswordVisible ? "text" : type}
      {...restProps}
      className={`${styles.textField} ${hasError ? styles.hasError : ""} ${className ?? ""}`}
      ref={ref}
    />
  );

  if (type === "password") {
    return (
      <div className={styles.container}>
        {input}
        <button
          type="button"
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          className={styles.passwordToggleButton}
        >
          <Icon name={isPasswordVisible ? "close-view" : "view"} className={styles.passwordIcon} />
        </button>
      </div>
    );
  }

  return <>{input}</>;
});
TextField.displayName = "TextField";
